// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0ad2b05e","496":"267613e6","498":"bbb632c5","703":"c38efe78"}[chunkId] + ".chunk.js";
};